import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, Share2, X } from "lucide-react";

const localDate = () => new Date().toLocaleDateString("en-CA");

export default function StreakRiskBanner({ user, onShare }) {
  const [now, setNow] = useState(new Date());
  const key = `sv_streak_risk_dismissed_${user.id}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(key) === localDate());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(t);
  }, []);

  const atRisk = user.streak_count > 0 && now.getHours() >= 20 && user.streak_last_activity !== localDate();
  if (!atRisk || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(key, localDate());
    setDismissed(true);
  };

  return (
    <div className="bg-[#1a1020] border-b border-[#7C5CFF]/30 px-5 py-2.5 flex items-center justify-between gap-4" data-testid="streak-risk-banner">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[13px]">
        <Flame size={15} className="text-[#F59E0B] shrink-0" />
        <span className="text-[#F4F4F5]">
          Your <strong>{user.streak_count}-day streak</strong> ends at midnight. Do a quick review to keep it alive.
        </span>
        <Link to="/app/review" className="text-[#B8A4FF] hover:underline font-medium" data-testid="streak-risk-review-link">Review now</Link>
        <button onClick={onShare} className="text-[#B8A4FF] hover:underline font-medium inline-flex items-center gap-1" data-testid="streak-share-card-btn">
          <Share2 size={12} /> Streak card
        </button>
      </div>
      <button onClick={dismiss} className="text-[#8E8B99] hover:text-white shrink-0" aria-label="Dismiss" data-testid="streak-risk-dismiss">
        <X size={14} />
      </button>
    </div>
  );
}
